import React, { useState } from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Button, Form, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useNavigate } from "react-router-dom";

const AccountAdd: React.FC = () => {
    const { userInfo, userToken, error: userError } = useSelector((state: RootState) => state.auth);
    const { vendorInfo, loading: vendorLoading, error: vendorError } = useSelector((state: RootState) => state.vendor);
    const [vendorAdmin, setVendorAdmin] = useState(false);
    const [vendorManager, setVendorManager] = useState(false);
    const [vendorEmployee, setVendorEmployee] = useState(false);
    const navigate = useNavigate();

    const handleCheckBox = (role: string) => {
        setVendorAdmin(false);
        setVendorManager(false);
        setVendorEmployee(false);

        if (role == 'vendor_admin') {
            setVendorAdmin(true);
        }

        if (role == 'vendor_manager') {
            setVendorManager(true);
        }

        if (role == 'vendor_employee') {
            setVendorEmployee(true);
        }
    }

    const handleSubmit = () => {
        let role = 'vendor_employee';

        if (vendorAdmin) {
            role = 'vendor_admin';
        }

        // if (vendorManager) {
        //     role = 'vendor_manager'
        // }

        if (vendorEmployee) {
            role = 'vendor_employee'
        }


        navigate(`/register?role=${role}`, {
            state: { targetRole: role }
        })
        // <Link to="/search_result" state={{ category: "new" }} style={{ textDecoration: "none" }}>

    }

    return (
        <>

            <section className="main-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-11 mx-auto">
                            <div className="login-wrapper py-lg-5 py-3 text-center">
                                <Image className="height-90 mb-2" src="assets/images/other/icon-users-tree-bg-white-circle-blue.svg" />
                                <div className="text-md mb-sm-5 mb-3 fw-400">追加登録ユーザーを選択する</div>
                                <div className="green-checkbox blue-checkbox item-wrapper-border-radius">
                                    <form id="account-form" action="register" method="get">
                                        <div className="row">
                                            <div className="col-lg-4 col-sm-6 row-eq-height">
                                                <div className="form-check form-check-inline w-100 m-0">
                                                    <input
                                                        onClick={(e) => handleCheckBox((e.target as HTMLInputElement).value)}
                                                        checked={vendorAdmin}
                                                        className="form-check-input childCheckBox"
                                                        type="checkbox"
                                                        id="checkBox01"
                                                        name="role"
                                                        value="vendor_admin"
                                                    />
                                                    <label className="form-check-label p-0" htmlFor="checkBox01">
                                                        <div className="checkbox-label text-center">
                                                            <div className="rainbow px-3 py-4">
                                                                <div className="top-left-border"></div>
                                                                <div className="right-border"></div>
                                                                <div className="bottom-border"></div>
                                                                <div className="mb-3">
                                                                    <img
                                                                        className="img img-fluid"
                                                                        src="assets/images/other/icon-user-plus-bg-white-circle-blue.svg"
                                                                    />
                                                                </div>
                                                                <div className="text-xs-2 fw-400">管理者アカウントを追加する</div>
                                                            </div>
                                                        </div>
                                                    </label>
                                                </div>
                                            </div>

                                            {/* <div className="col-lg-4 col-sm-6 row-eq-height">
                                                <Form.Group className="form-check form-check-inline w-100 m-0">
                                                    <Form.Control
                                                        onClick={(e) => handleCheckBox((e.target as HTMLInputElement).value)}
                                                        checked={vendorManager}
                                                        className="form-check-input childCheckBox"
                                                        type="checkbox" id="checkBox02" name="role"
                                                        value="vendor_manager" />
                                                    <Form.Label className="form-check-label p-0" htmlFor="checkBox02">
                                                        <div className=" text-center">
                                                            <div className="rainbow px-3 py-4">
                                                                <div className="top-left-border"></div>
                                                                <div className="right-border"></div>
                                                                <div className="bottom-border"></div>
                                                                <div className="mb-3">
                                                                    <Image className="img img-fluid" src="assets/images/other/icon-users-study-plus-bg-white-circle-blue.svg" />
                                                                </div>
                                                                <div className="text-xs-2 fw-400">責任者アカウントを追加する</div>
                                                                <p className="text-red-01 mb-0">※部署ごとのアカウントを管理するアカウントです</p>
                                                            </div>
                                                        </div>
                                                    </Form.Label>
                                                </Form.Group>
                                            </div> */}
                                            <div className="col-lg-4 col-sm-6 row-eq-height">
                                                <Form.Group className="form-check form-check-inline w-100 m-0">
                                                    <Form.Control
                                                        onClick={(e) => handleCheckBox((e.target as HTMLInputElement).value)}
                                                        checked={vendorEmployee}
                                                        className="form-check-input childCheckBox"
                                                        type="checkbox"
                                                        id="checkBox03"
                                                        name="role"
                                                        value="vendor_employee"
                                                    />
                                                    <Form.Label className="form-check-label p-0" htmlFor="checkBox03">
                                                        <div className="checkbox-label text-center">
                                                            <div className="rainbow px-3 py-4">
                                                                <div className="top-left-border"></div>
                                                                <div className="right-border"></div>
                                                                <div className="bottom-border"></div>
                                                                <div className="mb-3">
                                                                    <Image
                                                                        className="img img-fluid"
                                                                        src="assets/images/other/icon-users-plus-bg-white-circle-blue.svg"
                                                                    />
                                                                </div>
                                                                <div className="text-xs-2 fw-400">一般アカウントを追加する</div>
                                                                <p className="text-red-01 mb-0">※応札・閲覧が可能なアカウントです</p>
                                                            </div>
                                                        </div>
                                                    </Form.Label>
                                                </Form.Group>
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="py-3 mb-lg-5 mb-3 text-center">
                                <Button
                                    onClick={handleSubmit}
                                    type="button" id="submit" className="btn btn-theme btn-danger rounded-pill px-5 mr-2"><span className="mx-3">次へ</span></Button>
                                <Link to="/account" className="btn btn-theme btn-secondary rounded-pill px-4">前の画面に戻る</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default AccountAdd;